module.exports = __webpack_public_path__ + "static/slide6-318x245-c7453e802d4de05b7f627eabd1fb72b2.gif";